import { Users, TrendingUp, Building2, Award } from "lucide-react";
import { Link } from "react-router-dom";

export const BenefitsSection = () => {
  return (
    <div className="container mx-auto px-4 mb-16">
      <div className="grid md:grid-cols-3 gap-8 mb-12">
        <div className="flex flex-col items-center text-center p-6">
          <Users className="w-12 h-12 text-primary mb-4" />
          <h2 className="text-xl font-semibold mb-2">Targeted Exposure</h2>
          <p className="text-muted-foreground">
            Connect with homeowners actively seeking quality contractors in the OKC metro area
          </p>
        </div>
        
        <div className="flex flex-col items-center text-center p-6">
          <TrendingUp className="w-12 h-12 text-primary mb-4" />
          <h2 className="text-xl font-semibold mb-2">Quality Lead Generation</h2>
          <p className="text-muted-foreground">
            Receive inquiries from informed customers ready to start their projects
          </p>
        </div>
        
        <div className="flex flex-col items-center text-center p-6">
          <Building2 className="w-12 h-12 text-primary mb-4" />
          <h2 className="text-xl font-semibold mb-2">Professional Presence</h2>
          <p className="text-muted-foreground">
            Showcase your business on a trusted, local platform focused on quality service providers
          </p>
        </div>
      </div>

      <div className="bg-gradient-to-br from-[#174996]/10 to-[#0d2b59]/10 rounded-xl p-8">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
          <div className="flex-shrink-0">
            <Award className="w-16 h-16 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-3">Trust Badge for Your Website</h2>
            <p className="text-lg mb-4">
              Display your trusted status with our official Trust Badge. Show potential customers that you're verified and trusted by Oklahoma City's leading home service platform.
            </p>
            <Link 
              to="/badge-info"
              className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-medium"
            >
              Learn more about the Trust Badge
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};